import script from "./SecurityForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityForm.vue?vue&type=script&setup=true&lang=js"

import "./SecurityForm.vue?vue&type=style&index=0&id=40fa2c61&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40fa2c61"]])

export default __exports__